import { GrRefresh } from 'react-icons/gr';
import { IoIosArrowBack } from 'react-icons/io';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { MultichainSwapResult } from '@shared/types/actions';
import { Button } from '@/components/ui/button';
import classNames from '@/lib/misc/classNames';
import QuotingConfirmationString from './QuotingConfirmationString';
import { Skeleton } from '@/components/ui/skeleton';
import { useSwap } from '@/contexts/SwapProvider';
import { quoteString, validate } from '../swap-home/const';
import SwapQuoteData from './SwapQuoteData';
import QuoteError from './QuoteError';
import SwapSuccess from './SwapSuccess';
import SwapFail from './SwapFail';
import FixedBtnWrapper from '@/components/ui/FixBtnWrapper';
import getFeesFromQuote from '@/lib/trade/getFeesFromQuote';
import SwapLoader from '../SwapLoader';
import SwapSettings from './SwapSettings';
import { toSpecialFixed } from '@/lib/misc/utils';
import { useSession } from '@/contexts/LitSessionProvider';
import { useOrderHistory } from '@/hooks/db/useOrderHistory';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
export default function ConfirmSwapContent({
  setInfoType,
  setIsModalOpen,
  onClickBack
}) {
  const {
    PKP
  } = useSession();
  const {
    data,
    refetch: refetchOrderHistory
  } = useOrderHistory({
    cloudWallet: PKP?.additionalEthAddress,
    solanaAddress: PKP?.solanaAddress
  });
  const {
    handleOnRefresh,
    fromAssets,
    setFromAssets,
    toAssets,
    setToAssets,
    amount,
    timeUntilRefetchQuote,
    swapLoading,
    swapResult,
    quoteData,
    setSwapResult,
    quoteLoad,
    quoteFetching,
    swapWrapper,
    priceFetching,
    setIsConfirmationDialogOpen,
    toAssetPriceData,
    quoteRefetch,
    triggerQuote,
    resetAssets
  } = useSwap();
  const quoteStringInfo = quoteString(quoteData, toAssetPriceData);
  console.log('WUJI Quotedata', quoteData, quoteStringInfo);
  const isMobile = useIsMobile();
  const {
    sponsorFees,
    network
  } = getFeesFromQuote({
    quoteData
  });
  const [slippageOpen, setSlippageOpen] = useState(false);
  const router = useRouter();
  const urlHasTrade = router.asPath?.includes('trade');
  useEffect(() => {
    if (swapResult?.time) {
      resetAssets();
      refetchOrderHistory();
      console.log('swapResult:Success', {
        data
      });
    }
    return () => {};
  }, [swapResult]);
  if (swapLoading && isMobile) return <>
        <SwapLoader sponsorFees={sponsorFees} network={network} className={`${urlHasTrade ? 'h-screen' : 'h-full'} `} />
      </>;
  return <div className='h-full' data-sentry-component="ConfirmSwapContent" data-sentry-source-file="ConfirmSwapContent.tsx">
      {swapResult?.error ? <div className='w-full h-full'>
          <SwapFail swapLoading={swapLoading} setIsConfirmationDialogOpen={setIsConfirmationDialogOpen} quoteRefetch={quoteRefetch} setSwapResult={setSwapResult} onClickBack={onClickBack} />
        </div> : (swapResult as MultichainSwapResult)?.time && isMobile ? <div className='w-full'>
          <SwapSuccess swapLoading={swapLoading} swapResult={swapResult} setSwapResult={setSwapResult} setIsConfirmationDialogOpen={setIsConfirmationDialogOpen} setFromAssets={setFromAssets} setToAssets={setToAssets} />
        </div> : <div className='w-full h-full'>
          {(!quoteStringInfo?.message || priceFetching || quoteLoad || quoteFetching) && <div className={isMobile ? 'h-[72vh]' : ''}>
              <div className={classNames('md:h-fit z-80 relative overflow-auto rounded-b-3xl', {
          invisible: swapLoading,
          visible: !swapLoading
        })}>
                <div className='flex flex-col items-start justify-between w-full px-6 text-genius-cream md:cursor-pointer'>
                  {isMobile ? <>
                      {' '}
                      <Button type='button' variant='ghost' onClick={() => {
                setIsConfirmationDialogOpen(false);
                onClickBack && onClickBack();
              }} className='text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px] px-2'>
                        <IoIosArrowBack className={`w-[16px] text-genius-cream`} width={20} height={18} />{' '}
                        <p>Back</p>
                      </Button>
                    </> : <> </>}

                  {(priceFetching || quoteLoad || quoteFetching) && <>
                      <Skeleton className={`h-[40px] rounded-xl w-full mt-2 ${isMobile ? 'mt-4' : ''}`} />
                      <div className='flex flex-col mt-2 w-full'>
                        <div className='flex flex-col w-full'>
                          <Skeleton className='h-[60px] mt-2 rounded-xl' />
                          <div className='flex justify-between'>
                            <Skeleton className='h-[20px] w-[80px] mt-3 rounded-xl' />
                            <Skeleton className='h-[20px] w-[80px] mt-3 rounded-xl' />
                          </div>
                          {isMobile && <>
                              <div className='flex justify-between'>
                                <Skeleton className='h-[20px] w-[80px] mt-3 rounded-xl' />
                                <Skeleton className='h-[20px] w-[80px] mt-3 rounded-xl' />
                              </div>
                              <div className='flex justify-between'>
                                <Skeleton className='h-[20px] w-[80px] mt-3 rounded-xl' />
                                <Skeleton className='h-[20px] w-[80px] mt-3 rounded-xl' />
                              </div>
                              <Skeleton className='h-[60px] mt-6 rounded-xl' />
                            </>}
                        </div>
                      </div>
                    </>}

                  <div className='flex flex-col w-full mb-2'>
                    {quoteData && !quoteLoad && !quoteFetching && !priceFetching && !(swapResult as MultichainSwapResult)?.time && <div className='text-center text-5xl text-genius-cream font-normal mt-10 md:mt-0'>
                          {isMobile ? <>
                              {' '}
                              {toSpecialFixed(amount?.replace(',', ''), 2).value}
                              <span className='text-genius-cream/50 font-normal'> USD</span>
                            </> : <></>}

                          <div className='w-full  items-center text-genius-cream/50 flex justify-between text-sm mt-4'>
                            <p>New Quote in...</p>
                            <div className='flex items-center'>
                              <p className='text-sm px-4 text-genius-cream'>
                                {' '}
                                {timeUntilRefetchQuote} seconds
                              </p>
                              <div onClick={async () => {
                      await handleOnRefresh();
                    }} className='bg-genius-blue flex flex-col items-center p-1 text-genius-cream rounded-md cursor-pointer w-[30px] h-[30px]'>
                                <GrRefresh className='w-[20px] h-[20px]' />
                              </div>
                            </div>
                          </div>
                          {isMobile && <p className='text-sm text-genius-cream bg-genius-blue rounded-3xl mt-4 px-6 p-4 ta-l'>
                              <QuotingConfirmationString fromAssets={fromAssets} quoteStringInfo={quoteStringInfo} toAssets={toAssets} amount={amount} />
                            </p>}
                        </div>}
                  </div>
                </div>
                {/* dont flash swapquote data on successful swap */}
                {!swapResult?.time && !swapLoading && <>
                    <SwapQuoteData quoteData={quoteData} quoteStringInfo={quoteStringInfo} priceFetching={priceFetching} quoteFetching={quoteFetching} quoteLoad={quoteLoad} fromAssets={fromAssets} setInfoType={setInfoType} setIsModalOpen={setIsModalOpen} />
                  </>}
              </div>
            </div>}
          <SwapSettings isModalOpen={slippageOpen} toggleModal={() => setSlippageOpen(!slippageOpen)} />

          {quoteStringInfo?.message && validate(fromAssets, toAssets).valid && !quoteFetching ? <div className='h-[70vh] md:h-fit px-2 flex flex-col justify-between md:gap-12'>
              <QuoteError swapLoading={swapLoading} onClickBack={onClickBack} setIsConfirmationDialogOpen={setIsConfirmationDialogOpen} />
              <div>
                <Button className='w-full mb-2 rounded-full h-14 bg-genius-pink  text-genius-blue mt-4' onClick={async e => {
            e.preventDefault();
            console.log('setting slippy');
            setSwapResult(null);
            setSlippageOpen(true);
          }}>
                  Increase Slippage
                </Button>
                <Button className='w-full mb-4 rounded-full h-14 bg-genius-blue md:hover:bg-genius-blue text-genius-cream' onClick={async e => {
            e.preventDefault();
            setSwapResult(null);
            console.log('new quote trigger');
            await triggerQuote();
          }}>
                  Refresh
                </Button>
              </div>
            </div> : <div className='w-full'>
              {!swapLoading && !(swapResult as MultichainSwapResult)?.time && ((router.pathname === '/trade' || router.query.mode === 'trade') && isMobile ? <FixedBtnWrapper className='pb-[0px!important] bottom-[80px]'>
                    <Button onClick={async () => {
            await swapWrapper();
          }} disabled={!quoteData || quoteData?.quote?.error || quoteData?.quote?.message || priceFetching || quoteLoad || quoteFetching} className='w-full bg-genius-pink disabled:bg-genius-pink/50 md:hover:bg-genius-pink rounded-full  h-16  text-center font-medium'>
                      <Image src='/static/images/logo-3d.png' className='w-5 h-5 mr-4' alt='logo' width={20} height={20} />
                      <p className='font-light text-black font-semibold'>Submit Order</p>
                    </Button>
                  </FixedBtnWrapper> : <div className='w-full p-4'>
                    <Button onClick={async () => {
            await swapWrapper();
          }} disabled={!quoteData || quoteData?.quote?.error || quoteData?.quote?.message || priceFetching || quoteLoad || quoteFetching} className='w-full bg-genius-pink disabled:bg-genius-pink/50 md:hover:bg-genius-pink rounded-full  h-16  text-center font-medium'>
                      <Image src='/static/images/logo-3d.png' className='w-5 h-5 mr-4' alt='logo' width={20} height={20} />
                      <p className='font-light text-black font-semibold'>Submit Order</p>
                    </Button>
                  </div>)}
            </div>}
        </div>}
    </div>;
}